import * as React from "react";
import { action, observable } from "mobx";
import { observer, inject } from "mobx-react";
import { ILocalization } from "../../../models/localization";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { CourseOffering } from "../../../models/education";
import { OpportunityViewState } from "../../../models/enums";
import { LearnedSkill } from "../../../models/opportunity";
import Select from "material-ui/Select"
import { SetSkill } from "../../../models/opportunity";
import { Row, Col } from "react-flexbox-grid";
import TextField from "material-ui/TextField";
import { MenuItem } from "material-ui/Menu";
import Paper from "material-ui/Paper";
import List from "material-ui/List";
import Button from "material-ui/Button";
import * as s from "./build.css";


@inject("store") @observer
export default class BuildSkill extends React.Component<{ store: SeekerStore }, {}> {
  private buildRef: HTMLDivElement;
  constructor(props: any) {
    super(props);
    this.buildRef = null;
  }

  scrollToBottom = () => {
    this.buildRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  @action close = (): void => {
    this.props.store.profileStore.clearSelectedSkill();
    this.props.store.opportunityStore.clearSelectedSetSkill();
    this.props.store.opportunityStore.setViewState(0);
  }

  renderCourseContent(c: CourseOffering): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    if (c) {
      const url: string = c.institution.website || "#";
      const descriptionUrl = c.descriptionUrl || '#';
      const registerUrl = c.registrationUrl || '#';
        return (<Row key={c.institutionId + c.title}>
        <Col xs={12}><h6 className={s.courseTitle}>{c.title}{c.isOnline && <span className={s.online}>{local.addEducation.online}</span>}</h6></Col>
        {c.institution.name && < Col xs={12}><a href="#" target="_blank" className={s.institutionName} onClick={() => { this.props.store.viewState.showLink(url); }}>{c.institution.name}</a></Col>}
          <Col xs={12}><p>{c.description}</p></Col>
          {c.descriptionUrl && <Col xs={6} md={2}><a target="_blank" onClick={() => { this.props.store.viewState.showLink(descriptionUrl); }} ><p className={s.externalLinks}>{local.learnMore}</p></a></Col>}
          {c.registrationUrl && <Col xs={6} md={2}><a target="_blank" onClick={() => { this.props.store.viewState.showLink(registerUrl); }} ><p className={s.externalLinks} >{local.availCourses.register}</p></a></Col>}
        </Row>)
    }
  }

  renderContent(courses: Array<CourseOffering>): JSX.Element[] {
    const local: ILocalization = this.props.store.localization.fields;
    const items: JSX.Element[] = [];
    items.push(<Row key="education-header"><Col xs={12}><h6 className={s.skillTitle}>{`${local.opportunity.learn}: ${this.props.store.opportunityStore.selectedSetSkill.title}`}</h6></Col>
    </Row>)
    courses.map((c: CourseOffering): void => {
      c.skills.map((skill: LearnedSkill, i: number): void => {
        if (skill.skillId === this.props.store.opportunityStore.selectedSetSkill.skillId) {
          items.push(this.renderCourseContent(c));
          items.push(<hr key={i} />);
        }
      });
    })
    if (items.length === 1) {
      items.push(<div key="no-education-match"><p className={s.noMatch}>{`${local.opportunity.noEducationDlg}  ${this.props.store.opportunityStore.selectedSetSkill.title}.`}<br />{local.opportunity.checkBack}</p></div>)
    }
    items.push(<Row key="btn-col"><Col xs={12} className={s.btnCol}><Button raised size="large" color="secondary" onClick={this.close}>{local.close}</Button></Col></Row>)
    return items;
  }

  render(): JSX.Element {
    const co: Array<CourseOffering> = this.props.store.educationStore.courses;
    return (<div> <div style={{ float: "left", clear: "both" }} ref={(el) => { this.buildRef = el; }}></div>
      {this.props.store.opportunityStore.viewState === OpportunityViewState.BuildView && <div className={s.container}>{this.renderContent(co)}</div>}
    </div >)
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/buildIt/index.tsx